export const SelectStyles = {
    control: (styles) => ({
        ...styles,
        backgroundColor: '#fff',
        boxShadow: null,
    }),
    option: (styles, { isFocused, isSelected }) => {
        return {
            ...styles,
            fontSize: "14px",
            fontWeight: 500,
            backgroundColor: isSelected ? '#004aad' : isFocused ? '#e6f7ff' : null,
            color: isSelected ? '#fff' : isFocused ? '#004aad' : '#333333',
            '&:hover': {
                backgroundColor: isFocused ? '#e6f7ff' : '#fff',
                color: isFocused ? '#004aad' : '#333333',
            },
        };
    },
    input: (styles) => ({
        ...styles,
        fontSize: '14px'
    }),
    singleValue: (styles) => ({
        ...styles,
        fontSize: '14px'
    }),
    placeholder: (styles) => ({
        ...styles,
        fontSize: '14px'
    }),
    valueContainer: (styles) => ({
        ...styles,
    }),
    indicatorsContainer: (styles) => ({
        ...styles,
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        display: 'none'
    }),
    dropdownIndicator: (styles, { isFocused }) => ({
        ...styles,
        display: 'none',
        color: isFocused ? '#555' : '#777',
        '&:hover': {
            color: '#777',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        cursor: 'pointer',
        color: '#777',
        ':hover': {
            color: '#555'
        }
    })
};